import './ProgressApplication.css';
import React from 'react';
import { EStatus } from '../DAcApplication';
import { IconOk } from '../../atoms/Icons/';
const ProgressApplication = _ref => {
  let {
    rtl,
    steps,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "steps-wrapper"
  }, !!steps.length && steps.map((_ref2, i) => {
    let {
      id,
      title,
      status
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      key: id,
      className: `step ${status === EStatus.Active ? 'step--active' : status === EStatus.Completed ? 'step--completed' : ''}`,
      onClick: () => {}
    }, /*#__PURE__*/React.createElement("div", {
      className: "step__content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "step__number"
    }, status === EStatus.Completed ? /*#__PURE__*/React.createElement(IconOk, null) : i + 1), /*#__PURE__*/React.createElement("div", {
      className: "step__name"
    }, title)));
  })));
};
export default ProgressApplication;
const MAX_COMPACT_STEPS_WIDTH = '1411px';
const commonStyles = "c1ot4san";
const rtlStyles = "rf1dclo";
const ltrStyles = "livdn7v";